import {Type} from "../../helper";
import {L} from "../../../List/reducer";

export function getLists(transactionType) {
    switch (transactionType) {
        case Type.sale_quote:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.terms,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.contact_groups,
                L.form_designs,
            ];
        case Type.sale_order:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.contact_groups,
                L.terms,
                L.form_designs,
            ];
        case Type.sale_delivery_order:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.terms,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.contact_groups,
                L.form_designs,
            ];
        case Type.sale_invoice:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.tax_codes,
                L.terms,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.contact_groups,
                L.product_list,
                L.form_designs,
                L.payment_methods,
                L.classification_code_list,
            ];
        case Type.opening_invoice:
            return [
                L.contacts,
                L.currencies,
                L.tax_codes,
            ];
        case Type.sale_credit_note:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.contact_groups,
                L.form_designs,
                L.classification_code_list,
            ];
        case Type.opening_sale_credit_note:
            return [
                L.contacts,
                L.currencies,
                L.tax_codes,
            ];
        case Type.sale_payment:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.settings,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
                L.fields,
                L.form_designs,
                L.payment_methods,
            ];
        case Type.sale_refund:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.settings,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
                L.fields,
                L.form_designs,
                L.payment_methods,
            ];
        case Type.purchase_order:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.contact_groups,
                L.company_addresses,
                L.terms,
                L.form_designs,
            ];
        case Type.purchase_goods_received_note:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.terms,
                L.settings,
                L.tag_groups,
                L.fields,
                L.number_formats,
                L.locations,
                L.company_addresses,
                L.form_designs,
            ];
        case Type.purchase_bill:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.terms,
                L.settings,
                L.tag_groups,
                L.locations,
                L.number_formats,
                L.contact_groups,
                L.fields,
                L.form_designs,
                L.payment_methods,
                L.classification_code_list,
                L.company_addresses,
            ];
        case Type.opening_bill:
            return [
                L.contacts,
                L.currencies,
            ];
        case Type.purchase_credit_note:
            return [
                L.contacts,
                L.currencies,
                L.product_list,
                L.accounts,
                L.tax_codes,
                L.settings,
                L.tag_groups,
                L.locations,
                L.number_formats,
                L.contact_groups,
                L.fields,
                L.form_designs,
                L.classification_code_list,
                L.company_addresses,
            ];
        case Type.opening_purchase_credit_note:
            return [
                L.contacts,
                L.currencies,
            ];
        case Type.purchase_payment:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.settings,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
                L.fields,
                L.form_designs,
                L.payment_methods,
            ];
        case Type.purchase_refund:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.settings,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
                L.fields,
                L.form_designs,
                L.payment_methods,
            ];
        case Type.bank_income:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.tax_codes,
                L.settings,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
                L.form_designs,
                L.fields,
                L.payment_methods,
            ];
        case Type.bank_expense:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.settings,
                L.tax_codes,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
                L.form_designs,
                L.fields,
                L.payment_methods,
            ];
        case Type.bank_transfer:
            return [
                L.currencies,
                L.accounts,
                L.settings,
                L.tag_groups,
                L.number_formats,
            ];
        case Type.stock_adjustment:
            return [
                // L.products,
                L.product_list,
                L.accounts,
                L.settings,
                L.number_formats,
                L.locations,
                L.tag_groups,
            ];
        case Type.stock_transfer:
            return [
                // L.products,
                L.product_list,
                L.accounts,
                L.settings,
                L.locations,
                L.number_formats,
            ];
        case Type.contra:
            return [
                L.contacts,
                L.currencies,
                L.settings,
                L.tag_groups,
                L.number_formats,
            ];
        case Type.journal_entry:
            return [
                L.contacts,
                L.currencies,
                L.accounts,
                L.tax_codes,
                L.settings,
                L.tag_groups,
                L.number_formats,
                L.contact_groups,
            ];
        case Type.tax_deemed_payment:
            return [
                L.currencies,
                L.settings,
                L.tag_groups,
                L.number_formats,
            ];
        default:
            return [];
    }
}
